import { render, staticRenderFns } from "./HandlingStandardPage.vue?vue&type=template&id=63964f23"
import script from "./HandlingStandardPage.vue?vue&type=script&lang=js"
export * from "./HandlingStandardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports